import { useEffect, useState } from 'react'
import { useView } from '@10000/react'
import { ToolbarIconButton } from './Toolbar.jsx'
import { Avatar, Body, Box, Dialog, Icon, ItemPill } from '../../widgets'
import { PaidContent } from '../../free'
import { questions } from '../../../lookups'
import './QuestionOrder.scss'
import { randomiseLetters } from '../../../utilities'

export const QuestionOrder = ({ small }) => {
  const [orderOpen, setOrderOpen] = useState(false)
  const { presenter, questionOrder, questionIndex } = useView('squiz')

  const activeQuestion = questionOrder?.[questionIndex]

  useEffect(() => {
    if(presenter){
      document.getElementById(`${activeQuestion}-question`)?.scrollIntoView({ block: "nearest", inline: 'end' })
    }
  }, [orderOpen, presenter, questionIndex, activeQuestion])

  return (
    <>
      <Dialog onClose={() => setOrderOpen(false)} open={orderOpen} showControls={false} mobileBackground="white">
        <Box alignItems="start" className="queue-title" fullWidth>
          <Body bold color="black">Question queue</Body>
        </Box>
        {presenter && (
          <Box column gap={8} fullWidth overflow="auto" maxHeight="50dvh">
            {questionOrder.map((question, index) =>
              <QuestionPill key={index} question={question} index={index} />
            )}
          </Box>
        )}
      </Dialog>
      <ToolbarIconButton
        icon="Order"
        size={small ? 39 : 58}
        iconSize={small ? 24 : 32}
        onClick={() => setOrderOpen(true)}
        toolTipText="Show question order"
      />
    </>
  )
}

const QuestionPill = ({ question, index }) => {
  const { questionIndex, options: { questionCount } } = useView('squiz')

  const text = questions[question].question

  return (
    <ItemPill key={index} alt={(index === questionIndex) ? 'black' : 'light-grey'}>
      {index >= questionCount && <PaidContent />}

      <Box fullWidth alignItems="center" gap={8} id={question + '-question'}>
        <Avatar size="small" index={Math.floor(question / 2)} mode="practice"/>
        <Box fullWidth className="question" >
          <Body align="left" lineHeight={1.2}>{index >= questionCount ? randomiseLetters(text) : text}</Body>
        </Box>
        {(index === questionIndex) && <Icon icon="PlayWithCircle" />}
      </Box>
    </ItemPill>
  )
}